import {
  DownloadResultManager,
  ServiceUsingCountManager,
  ServiceUsingTextManager,
} from "@/services/license/base/license-manager-abstractions";
import { TextToSpeechCountLimiter } from "@/services/license/license-limiters/service-using-count-limiters/text-to-speech-count-limiter";
import { TextToSpeechTextLimiter } from "@/services/license/license-limiters/service-using-text-limiters/text-to-speech-text-limiter";
import { TrialDownloadResultLimiter } from "@/services/license/license-limiters/download-result-limiters/trial-download-result-limiter";

export class TextToSpeechLicenseManager
  implements
    ServiceUsingCountManager,
    ServiceUsingTextManager,
    DownloadResultManager
{
  serviceUsingCountLimiter = new TextToSpeechCountLimiter();
  serviceUsingTextLimiter = new TextToSpeechTextLimiter();
  downloadResultLimiter = new TrialDownloadResultLimiter();
}

const textToSpeechLicenseManager = new TextToSpeechLicenseManager();
export { textToSpeechLicenseManager };
